import { GENERATION_TOOL, type GenerationTool } from 'src/data/generationTool';

import { INFINITY_HOST_TYPE, type InfinityHostType } from './const';

type HostToolCallback = ({
  text,
  allowMixed,
}: {
  text: string;
  allowMixed: boolean;
}) => GenerationTool;

const INFINITY_HOST_TOOL_MAP: Partial<Record<InfinityHostType, GenerationTool | HostToolCallback>> =
  {
    [INFINITY_HOST_TYPE.facebook]: GENERATION_TOOL.facebookPost,

    [INFINITY_HOST_TYPE.metaAds]: ({ text, allowMixed }) => {
      if (allowMixed) {
        return GENERATION_TOOL.facebookMixtureAd;
      }

      return isLongText(text)
        ? GENERATION_TOOL.facebookPrimaryTextProduct
        : GENERATION_TOOL.facebookHeadlineProduct;
    },

    [INFINITY_HOST_TYPE.instagram]: GENERATION_TOOL.instagramCaption,

    [INFINITY_HOST_TYPE.twitter]: GENERATION_TOOL.tweet,

    [INFINITY_HOST_TYPE.twitterAds]: ({ text, allowMixed }) => {
      if (allowMixed) {
        return GENERATION_TOOL.twitterMixtureAd;
      }

      return isLongText(text)
        ? GENERATION_TOOL.twitterCopyProduct
        : GENERATION_TOOL.twitterTitleProduct;
    },

    [INFINITY_HOST_TYPE.gmail]: ({ text, allowMixed }) => {
      if (allowMixed) {
        return GENERATION_TOOL.emailMixture;
      }

      return isLongText(text)
        ? GENERATION_TOOL.emailColdOutreachBody
        : GENERATION_TOOL.emailSubject;
    },

    [INFINITY_HOST_TYPE.youtube]: ({ text, allowMixed }) => {
      return isLongText(text) || allowMixed
        ? GENERATION_TOOL.youtubeDescription
        : GENERATION_TOOL.youtubeTitle;
    },

    [INFINITY_HOST_TYPE.linkedIn]: GENERATION_TOOL.linkedinPost,

    [INFINITY_HOST_TYPE.linkedInAds]: ({ text, allowMixed }) => {
      if (allowMixed) {
        return GENERATION_TOOL.linkedinMixtureAd;
      }

      return isLongText(text)
        ? GENERATION_TOOL.linkedinIntroSingleImage
        : GENERATION_TOOL.linkedinHeadlineSingleImage;
    },

    [INFINITY_HOST_TYPE.googleAds]: ({ allowMixed }) => {
      return allowMixed ? GENERATION_TOOL.googleRSA : GENERATION_TOOL.googleDescriptionProduct;
    },
  };

const isLongText = (text: string): boolean => {
  return text?.length > 120;
};

export const getInfinityHostDefaultGenerationTool = ({
  hostType,
  text,
  allowMixed,
}: {
  hostType: InfinityHostType;
  text: string;
  allowMixed: boolean;
}): GenerationTool | undefined => {
  const defaultTool = INFINITY_HOST_TOOL_MAP[hostType];
  if (typeof defaultTool === 'function') {
    return defaultTool({ text, allowMixed });
  }
  return defaultTool;
};

export const infinityHostHasDefaultGenerationTool = (hostType: InfinityHostType): boolean => {
  return INFINITY_HOST_TOOL_MAP[hostType] !== undefined;
};
